import { GET_ALL_COURSE, GET_IMPORTANT_COURSE } from '@plugins/service/api/urls'
import { IMPORTANT_COURSE_HEADER } from '@plugins/service/cache-timer'
import { checkStatus } from '@helper/utils'
export async function changeShowCategory ({ commit }, payload) {
  await commit('CHANGE_SHOW_CATEGORY', payload)
}
export async function getImportantCourse ({ commit }) {
  try {
    const { data, status } = await this.$api.index({
      url: GET_IMPORTANT_COURSE
    //  useCache: IMPORTANT_COURSE_HEADER
    })
    if (checkStatus(status)) {
      commit('SET_IMPORTANT_COURSE', data)
    }
  } catch (error) {
    this.$logger.captureException({ error })
  }
}
export async function getCourse ({ commit }, { course_group_id }) {
  try {
    const { data, status } = await this.$api.index({
      url: GET_ALL_COURSE,
      query: { course_group_id }
    })
    if (checkStatus(status)) {
      const { selected_group_courses, course_groups } = data
      commit('SET_COURSE_GROUPS', course_groups)
      commit('SET_SELECTED_GROUP_COURSE', selected_group_courses)
    }
  } catch (error) {
    this.$logger.captureException({ error })
  }
}
export function setSelectedCourse ({ commit }, { course_group_id }) {
  try {
    commit('SET_SELECTED_ACTIVE', { course_group_id })
  } catch (error) {
    this.$logger.captureException({ error })
  }
}
